import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { selectFee } from "~/store/fee/feeActions";
import { withRouter } from "react-router-dom";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PaymentConfirmInformationPageMobile = Loadable({
  loader: () =>
    import(/* mobile */ "~/components/desktop/pages/FeeResultSearch"),
  loading: LoadableLoading
});
const PaymentConfirmInformationPageDesktop = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/FeeResultSearch"),
  loading: LoadableLoading
});

class DetectPaymentConfirmInformation extends Component {
  methods = {
    handleSelectFee: fee => {
      this.props.selectFee(fee);
      this.props.history.push("/hinh-thuc-thanh-toan-vien-phi");
    },
    handleGoBack: () => {
      const { history } = this.props;
      history.push("/tim-ma-thanh-toan-vien-phi");
    }
  };

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <PaymentConfirmInformationPageMobile
            {...this.props}
            {...this.methods}
          />
        ) : (
          <PaymentConfirmInformationPageDesktop
            {...this.props}
            {...this.methods}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    fee: { listFee, patient }
  } = state;
  return {
    device: type,
    listFee,
    patient
  };
};

const PaymentConfirmInformationHelmet = withTitle({
  component: DetectPaymentConfirmInformation,
  title: `${hospitalName.value} | Xác nhận thông tin thanh toán`
});

export default connect(mapStateToProps, { selectFee })(
  withRouter(PaymentConfirmInformationHelmet)
);
